<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
      <v-data-table
        :headers="headers"
        :items="desserts"
        :loading="loading"
        :search="search"
         height="50vh"
        fixed-header
        :sort-desc="[false, true]"
        multi-sort
        dark
        dense
        class="table"
        item-key="email"
        scope="props"
      >
        <template v-slot:top>
          <v-toolbar flat dark rounded>
            <v-toolbar-title>Users</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <export-excel :data="desserts" name="users">
              <v-btn color="primary"><v-icon color="white">mdi-file-download</v-icon></v-btn>
            </export-excel>
          </v-toolbar>
        </template>
        <template v-slot:[`item.profile`]="{ item }">
          <span @click="openProfileDialog(item.profile, 'profileDialog')"><a>Ver</a></span>
          <v-dialog v-model="profileDialog.enabled" max-width="300">
            <v-container>
              <v-row class="flex-column">
                <div class="d-flex">Nome: <span class="ml-auto gold">{{ profileDialog.items.fullName }}</span></div>
                <div class="d-flex">Telefone: <span class="ml-auto gold">{{ profileDialog.items.phone }}</span></div>
                <div class="d-flex">CPF: <span class="ml-auto gold">{{ profileDialog.items.cpf }}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.bankAccount`]="{ item }">
          <span @click="openBankAccountDialog(item.bankAccount)"><a>Ver</a></span>
          <v-dialog v-model="bankAccountDialog.enabled" max-width="300">
            <v-container>
              <v-row class="flex-column">
                <div class="d-flex">Banco: <span class="ml-auto gold">{{bankAccountDialog.bankAccount.bank.code}} - {{ bankAccountDialog.bankAccount.bank.name }}</span></div>
                <div class="d-flex">Agência: <span class="ml-auto gold">{{ bankAccountDialog.bankAccount.branchNumber }}</span></div>
                <div class="d-flex">Conta: <span class="ml-auto gold">{{ bankAccountDialog.bankAccount.accountNumber }} - {{ bankAccountDialog.bankAccount.accountDigit }}</span></div>
                <div class="d-flex my-5 mx-auto">Titular</div>
                <div class="d-flex">Nome: <span class="ml-auto gold">{{ bankAccountDialog.bankAccount.holder.name }}</span></div>
                <div class="d-flex">CPF: <span class="ml-auto gold">{{ bankAccountDialog.bankAccount.holder.cpf }}</span></div>
                <div class="d-flex">E-mail: <span class="ml-auto gold">{{ bankAccountDialog.bankAccount.holder.email }}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.config`]="{ item }">
          <span @click="openConfigDialog(item)"><a>Ver / Editar</a></span>
          <v-dialog v-model="configDialog.enabled" max-width="300" :retain-focus="false">
            <!-- removing property :retain-focus above will result in a overflow with message of kind: "Too much recursion" -->
            <v-card>
              <v-card-title>
                <span class="headline gold">{{ translateGeneralWordsAndPhrases(formTitle) }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-currency-field :label="translateGeneralWordsAndPhrases('Tax')" v-model="configDialog.editedItem.withDraw.tax"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox v-model="configDialog.editedItem.withDraw.isFree" :label="translateGeneralWordsAndPhrases('Free')"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="white" text @click="configDialog.enabled = false">{{ translateGeneralWordsAndPhrases('Cancel') }}</v-btn>
                <v-btn color="primary" text @click="saveConfig(configDialog.itemIndex)">{{ translateGeneralWordsAndPhrases('Save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ item.createdAt | date }}</span>
        </template>
        <!-- coluna de telefone -->
        <template v-slot:[`item.phone`]="{ item }">
          <span>{{   formatphone(item.profile.phone) }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" small @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      </v-row>
    </v-container>
  </v-main>
</template>

<style lang="scss">
  .table {
    width: 90%;
    z-index: 1;
    .search {
      margin-right: 25px;
      max-width: 300px;
    }
  }
  th {
    span { font-size: 15px; }
    color: gold !important;
  }
  .v-dialog { box-shadow: none !important; }
  .large { min-width: 125px; }
  .gold { color: gold; }
  .pointer { cursor: pointer; }
</style>

<script>
/* eslint-disable */
import { upperCaseFirstLetter } from '@/utils/strings'
import { formatDate } from '@/utils/date'

const translatedTableTitles = {}
const translatedTableFields = {}
const translatedGeneralWordsAndPhrases = {}

const hiddenTableColumns = ['id', 'link']

export default {
  name: 'Users',
  data () {
    return {
      loading: true,
      search: '',
      headers: [],
      desserts: [],
      profileDialog: {
        enabled: false,
        items: []
      },
      bankAccountDialog: {
        enabled: false,
        bankAccount: {
          type: '',
          accountDigit: '',
          accountNumber: '',
          branchNumber: '',
          bankID: '',
          bank: {},
          holder: {}
        }
      },
      configDialog: {
        enabled: false,
        itemIndex: -1,
        defaultItem: {
          withDraw: {
            isFree: false,
            tax: 0
          },
          defaultListId: '' 
        }, 
        editedItem: {
          withDraw: {
            isFree: false,
            tax: 0
          },
          defaultListId: ''
        }
      }
    }
  },
  mounted () {
    let headerCreated = false
    let dessert = {}

    this.$axios.get('user/all').then(res => {
      res.data.forEach(user => {
        if (!headerCreated) {
          for (const key of Object.entries(user))
          {         
            this.headers.push({ text: upperCaseFirstLetter(key[0]), value: key[0], class: 'large', align: hiddenTableColumns.includes(key[0]) ? ' d-none' : '' })
          }
          this.headers.push({ text: "Phone",value: "phone", class: 'large', align: hiddenTableColumns.includes("phone") ? ' d-none' : '' })
          headerCreated = true;
        }
        dessert = {}
        for (const key of Object.entries(user)) {  
          dessert = {...dessert, [key[0]]: key[1]}
        }
        this.desserts.push(dessert)
      });
      this.loading = false
    })
    .catch(err => console.log(err))
  },
  computed: {
    formTitle () { return this.configDialog.itemIndex === -1 ? 'Include Config' : 'Edit Config' }
  },
  methods: {
    openProfileDialog (items) {
      items.fullName = items.firstName + ' ' + items.lastName
      this.$set(this, 'profileDialog', { enabled: true, items })
    },
    openBankAccountDialog (item) {
      if (item === undefined) {
        alert('There is no bank data for this user or he didnt create his account.')
        return
      }
      Object.assign(this.bankAccountDialog, {enabled: true, bankAccount: item})
    },
    openConfigDialog (item) {
      if (item === undefined) {
        alert('There is no config data setted for this user.')
        return
      }

      this.configDialog = {
        enabled: true, 
        itemIndex: this.desserts.indexOf(item), 
        editedItem: { ...item.config },
        defaultItem: { ...this.configDialog.defaultItem }
      }
    },
    async saveConfig (index) {
      if (index > -1) { // Editing the category
        try {
          const user = { ... this.desserts[index] }
          user.config.withDraw = {
            tax: this.configDialog.editedItem.withDraw.tax,
            isFree: this.configDialog.editedItem.withDraw.isFree
          }

          await this.$axios.put('user/' + user.id, user).then()
        } catch (err) { console.log(err) } 
        finally { Object.assign(this.desserts[index].config, this.configDialog.editedItem) }
      } 
      
      this.configDialog = {
        enabled: false, 
        itemIndex: -1, 
        editedItem: { ...this.configDialog.defaultItem },
        defaultItem: { ...this.configDialog.defaultItem }
      }
    },
    translateTableTitle (word) { return (word in translatedTableTitles) ? translatedTableTitles[word] : word },
    translateTableField (word) { return (word in translatedTableFields) ? translatedTableFields[word] : word },
    translateGeneralWordsAndPhrases (expression) { return (expression in translatedGeneralWordsAndPhrases) ? translatedGeneralWordsAndPhrases[expression] : expression },
    formatDate(date) { return formatDate(date) }   ,
    
     formatphone(phone) {
      if(phone.slice(-4) == "+55") return "S/N";
      else if( phone.slice(-9,-8) == 9)return "(" + phone.slice(-11,-9) + ") " + phone.slice(-9,-8) + phone.slice(-8,-4) + "-" + phone.slice(-4);
      else return "(" + phone.slice(-10,-8) + ") " + phone.slice(-8,-4) + "-" + phone.slice(-4);
    } 

  },
}
</script>